var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3607 21.4844H5.07942L4.29817 9.61726C4.29276 9.5354 4.30437 9.45331 4.33228 9.37617C4.36018 9.29902 4.40377 9.2285 4.46029 9.16904C4.51681 9.10958 4.58504 9.06248 4.66067 9.03071C4.73631 8.99894 4.8177 8.98319 4.89973 8.98444H7.81379C7.94842 8.98384 8.08134 9.01458 8.20202 9.07425C8.32271 9.13391 8.42784 9.22086 8.5091 9.32819L9.46223 10.5469H18.3607V12.1094",
    stroke: "#F33A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5469 16.1719L21.2031 13.6719H7.22656L5.07812 21.4844H18.2891C18.5338 21.4838 18.7715 21.4022 18.9651 21.2524C19.1587 21.1026 19.2973 20.893 19.3594 20.6563L19.9531 18.4062",
    stroke: "#F33A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 19.1421C13.0984 18.936 13.3792 18.8203 13.6719 18.8203C13.9645 18.8203 14.2453 18.936 14.4531 19.1421V19.1421",
    stroke: "#F33A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5469 16.7969H11.3281",
    stroke: "#F33A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0156 16.7969H16.7969",
    stroke: "#F33A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1094 2.82031C14.2578 3.125 12.8906 4.19531 12.8906 5.46875C12.9029 5.96375 13.0977 6.43674 13.4375 6.79687L12.8906 8.98437L15.125 7.86719C15.7892 8.09241 16.4862 8.20593 17.1875 8.20312C19.5312 8.20312 21.4844 6.97656 21.4844 5.46875C21.4844 4.21875 20.1641 3.16406 18.3594 2.83594",
    stroke: "#F33A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6016 4.88281L17.7734 6.05469",
    stroke: "#F33A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7734 4.88281L16.6016 6.05469",
    stroke: "#F33A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataNotFound);
export default __webpack_public_path__ + "static/media/data-not-found.f1e6896452977f80f1cdcb63c7413772.svg";
export { ForwardRef as ReactComponent };